import 'svelte/internal/disclose-version';

Calendar[$.FILENAME] = 'client/lib/Calendar.svelte';

import * as $ from 'svelte/internal/client';

var root = $.add_locations($.from_html(`<div class="mt-1"><!></div>`), Calendar[$.FILENAME], [[14, 18]]);

var root_1 = $.add_locations(
	$.from_html(
		`

<button>
  <span class="absolute -top-4 left-6 h-8 w-3 rounded-full border-[3px] border-ink bg-paper"></span>
  <span class="absolute -top-4 right-6 h-8 w-3 rounded-full border-[3px] border-ink bg-paper"></span>
  <div> </div>
  <div class="px-3 py-2 text-center">
    <p> </p>
    <p> </p>
    <!>
  </div>
</button>`,
		1
	),
	Calendar[$.FILENAME],
	[
		[7, 0, [[8, 2], [9, 2], [10, 2], [11, 2, [[12, 4], [13, 4]]]]]
	]
);

function Calendar($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Calendar);

	let past = $.prop($$props, 'past', 3, false),
		tilt = $.prop($$props, 'tilt', 19, () => -1.5),
		small = $.prop($$props, 'small', 3, false),
		cls = $.prop($$props, 'class', 3, "");

	const [day, month, year] = $$props.date.replace(/^\S+\s(?=\d)/, "").split(" ");
	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_1();
	var button = $.sibling($.first_child(fragment));
	var div = $.sibling($.child(button), 5);
	var text = $.only_child(div);
	var div_1 = $.sibling(div, 2);
	var p = $.sibling($.child(div_1));
	var text_1 = $.only_child(p, true);
	var p_1 = $.sibling(p, 2);
	var text_2 = $.only_child(p_1, true);
	var node = $.sibling(p_1, 2);

	{
		var consequent = ($$anchor) => {
			var div_2 = root();
			var node_1 = $.child(div_2);

			$.add_svelte_meta(() => $.snippet(node_1, () => $$props.children), 'render', Calendar, 14, 36);
			$.reset(div_2);
			$.append($$anchor, div_2);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if ($$props.children) $$render(consequent);
			}),
			'if',
			Calendar,
			14,
			4
		);
	}

	$.next();
	$.reset(div_1);
	$.next();
	$.reset(button);

	$.template_effect(() => {
		$.set_class(button, 1, `group relative shrink-0 border-[3px] border-ink bg-white text-left shadow-[7px_7px_0_#17150f] transition hover:-translate-y-1 ${small() ? 'w-44' : 'w-72'} ${cls() ?? ''}`);
		$.set_style(button, `transform: rotate(${tilt() ?? ''}deg)`);

		$.set_class(div, 1, `border-b-[3px] border-ink px-3 pt-4 pb-1 text-center font-comic tracking-wide ${small() ? 'text-lg' : 'text-2xl'} ${past()
			? 'bg-ink text-white'
			: $.strict_equals($$props.type, 'Golden Day') ? 'bg-gold' : 'bg-sky text-white'}`);

		$.set_text(text, `${month ?? ''} ${year ?? ''}`);
		$.set_class(p, 1, `font-comic leading-none ${small() ? 'text-6xl' : 'text-9xl'} text-orange [text-shadow:3px_3px_0_#17150f]`);
		$.set_text(text_1, day);
		$.set_class(p_1, 1, `font-comic tracking-wide text-cobalt ${small() ? 'text-base' : 'text-xl'}`);
		$.set_text(text_2, past() ? "Première édition" : $$props.type);
	});

	$.delegated('click', button, function (...$$args) {
		$.apply(() => $$props.onclick, this, $$args, Calendar, [7, 9]);
	});

	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Calendar = $.hmr(Calendar);

	import.meta.hot.accept((module) => {
		Calendar[$.HMR].update(module.default);
	});
}

export default Calendar;

$.delegate(['click']);